export default {
  custom: {
    confirm_password: {
      required: 'We require you to confirm your password',
      confirmed: 'You passwords do not match yet'
    },
    full_name: {
      required: 'We require your full name',
      min: 'Please provide your full name'
    },
    user_full_name: {
      required: 'We require your full name',
      min: 'Please provide your full name'
    },
    emailAddress: {
      required: 'We require an email address',
      email: 'The email provided is not a valid'
    },
    work_email: {
      required: 'We require your email address',
      email: 'The email provided is not a valid'
    },
    password: {
      required: 'Please provide a password',
      min: 'Your password should be at least 5 characters long'
    },
    business_name: {
      required: 'We require a name for your business',
      min: 'Your business name should be at least 3 characters long'
    },
    role: {
      required: 'We require you to select a role'
    },
    service_name: {
      required: 'We require you provide a name for your service',
      min: 'Your business name should be at least 3 characters long'
    },
    country_of_operation: {
      required: 'Please select you country of operation'
    },
    phone_number: {
      required: 'We require your mobile number'
    },
    visit_amount: {
      required: 'We require you to provide an amount'
    },
    user_phone_number: {
      required: 'We require your mobile number'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/validation/en.js